<template>
  <interview-layout :touch-and-validate="touchAndValidate" :show-help-button="true">
    <!-- inner wrapper used for centering -->
    <div class="flex-grow-1" style="max-width: 438px;">
      <!-- title above form card -->
      <h1 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200 max-100">Woninginformatie</h1>

      <!-- form 1 card -->
      <base-card class="flex-grow-1" inner-class="container d-flex" color="alternate" :outer-padding="true">
        <base-form @submit="onSubmit" class="w-100">

          <!-- inputs -->
          <base-input
            type="number"
            name="ConstructionYear" fieldWidth="140px"
            input-class="fs-4"
            v-model:value="lead.property.ConstructionYear" :validator="v$.property.ConstructionYear">
            Wat is het bouwjaar van uw woning?
          </base-input>
          <issue-feedback :issue="qualStore.global.rules.ConstructionYear" />
          
          <!-- <div class="d-flex flex-wrap flex-row max-100">

            <base-input
              type="number"
              class="me-5"
              name="GasConsumption" fieldWidth="200px"
              field-background="gray-200"
              v-model:value="lead.property.GasConsumption"
              :validator="v$.property.GasConsumption"
              :do-not-reward="true"
              force-validation-state="warning"
              force-validation-message="Gasverbruik per jaar"
            >
              <template #default>
                <i class="bi bi-fire"></i>
                Wat is uw gasverbruik per jaar?
              </template>
              <template #after>
                  <span class="unit px-2 small fw-600 text-secondary">m<sup>3</sup></span>
              </template>
            </base-input>

            <base-input
              type="number"
              class="me-5"
              name="PowerConsumption" fieldWidth="200px"
              field-background="gray-200"
              v-model:value="lead.property.PowerConsumption"
              :validator="v$.property.PowerConsumption"
              :do-not-reward="true"
              force-validation-state="warning"
              force-validation-message="Stroomverbruik per jaar"
            >
              <template #default>
                <i class="bi bi-lightning-fill"></i>
                Wat is uw stroomverbruik per jaar?
              </template>
              <template #after>
                  <span class="unit px-2 small fw-600 text-secondary">kWh</span>
              </template>
            </base-input>

          </div> -->

          <!-- HouseType -->
          <base-input
            type="radiobuttons" :options="houseTypeOptions"
            name="HouseType" direction="column"
            v-model:value="lead.property.HouseType" :validator="v$.property.HouseType" force-validation-state="neutral">
            Welk type woning heeft u?
          </base-input>

          <!-- InVersterkingsprogramma -->
          <base-input
            v-show="showItem.InVersterkingsprogramma"
            type="radiobuttons" :options="yesNo"
            name="InVersterkingsprogramma" direction="row"
            v-model:value="lead.property.InVersterkingsprogramma" :validator="v$.property.InVersterkingsprogramma">
            Zit uw woning in het versterkingsprogramma?
          </base-input>

          <info-item v-if="!this.lead.municipalityHasNoVersterking" icon="bi-info-circle-fill text-info small" style="font-size: 0.9em;" class="mb-4 opacity-90 fst-italic">
            Als uw woning deel uitmaakt van het versterkingsprogramma heeft u hierover een brief ontvangen van Nationaal Coördinator Groningen (NCG) of uw gemeente.
          </info-item>

          <!-- VersterkingsprogrammaAausgevoerd (only shown if InVersterkingsprogramma is true) -->
          <base-input
            v-show="lead.property.InVersterkingsprogramma === true"
            type="radiobuttons" :options="yesNo"
            name="VersterkingsprogrammaAausgevoerd" direction="row"
            v-model:value="lead.property.VersterkingsprogrammaUitgevoerd" :validator="v$.property.VersterkingsprogrammaUitgevoerd">
            Is de versterking al uitgevoerd?
          </base-input>
          <issue-feedback :issue="qualStore.global.rules.InVersterkingsprogramma" />

          <!-- IsMonument -->
          <base-input
            v-show="showItem.IsMonument"
            type="radiobuttons" :options="yesNo"
            name="IsMonument" direction="row"
            v-model:value="lead.property.IsMonument" :validator="v$.property.IsMonument">
            Is uw woning een (rijks)monument?
          </base-input>
          <issue-feedback :issue="qualStore.global.rules.IsMonument" />

          <!-- IsBeschermdGezicht -->
          <base-input
            v-show="showItem.IsBeschermdGezicht"
            type="radiobuttons" :options="yesNo"
            name="IsBeschermdGezicht" direction="row"
            v-model:value="lead.property.IsBeschermdGezicht" :validator="v$.property.IsBeschermdGezicht">
            Valt uw woning onder een beschermd stads-/dorpsgezicht?
          </base-input>

          <!-- info item, with linked to map of beschermde gezichten: https://rce.webgis.nl/nl/map/stads-en-dorpsgezichten -->
          <info-item v-if="showItem.IsBeschermdGezicht" icon="bi-box-arrow-up-right text-info small" style="font-size: 0.9em;" class="mb-1 opacity-90 fst-italic">
            <a href="https://rce.webgis.nl/nl/map/stads-en-dorpsgezichten" target="_blank">Klik hier voor de kaart met beschermde gezichten</a> van de Rijksdienst voor het Cultureel Erfgoed.
          </info-item>

          <!-- buttons -->
          <button-row class="mt-5">
            <base-button class="ms-auto" icon="bi-arrow-right" type="submit" :disabled="shouldDisableNext">Volgende</base-button>
          </button-row>
        </base-form>
      <!-- form card end -->
      </base-card>

      <button-row class="mt-2">
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
      <!-- inner wrapper end -->
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue"
  import BaseCard from '@/components/BaseCard.vue'
  import BaseForm from "@/components/BaseForm.vue"
  import BaseInput from "@/components/BaseInput.vue"
  import BaseButton from "@/components/BaseButton.vue"
  import ButtonRow from "@/components/ButtonRow.vue"
  import IssueFeedback from "@/components/IssueFeedback.vue"
  import InfoItem from "@/components/InfoItem.vue"

  import { useAllStores } from "@/helpers/UseAllStores";
  import { CommonComposable } from "@/helpers/CommonComposable"
  import { FlowService } from "@/services/FlowService"

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseInput,
      BaseButton,
      ButtonRow,
      IssueFeedback,
      InfoItem
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    data() {
      return {
        yesNo: [
          {
            label: 'Ja',
            value: true
          },
          {
            label: 'Nee',
            value: false
          },
        ],
      };
    },
    computed: {
      houseTypeOptions() {
        return [
          { label: 'Tussenwoning', value: 'Tussenwoning' },
          { label: 'Hoekwoning', value: 'Hoekwoning' },
          { label: 'Twee onder één kap', value: 'Twee onder één kap' },
          { label: 'Vrijstaande woning', value: 'Vrijstaande woning' },
          { label: 'Geschakelde woning', value: 'Geschakelde woning' },
          { label: 'Appartement', value: 'Appartement' },
          { label: 'Bungalow', value: 'Bungalow' },
          { label: 'Woonboot', value: 'Woonboot' },
          { label: 'Woonwagen', value: 'Woonwagen' },
          // { label: 'Garage', value: 'Garage' },
          { label: 'Anders', value: 'Anders' }
        ];
      },
      hasAdviesAccess() {
        return FlowService.getAllowedSection(this.$route.query.section) === 'advies';
      },
      isInIntakeSection() {
        const viewKey = FlowService.getViewKeyFromName(this.$route.name);
        if (viewKey === null) return false;
        const view = FlowService.sequence[viewKey];
        return view.section === 'intake';
      },
      shouldDisableNext() {
        if (this.hasAdviesAccess && this.isInIntakeSection) {
          return false;
        }
        return this.v$.property.$invalid;
      },
      showItem() {
        let items = {
          InVersterkingsprogramma: false,
          IsMonument: false,
          IsBeschermdGezicht: false,
        };
        if (this.v$.property.HouseType && this.v$.property.ConstructionYear) {
          items.InVersterkingsprogramma = !this.lead.municipalityHasNoVersterking;
          items.IsMonument = true;
        }
        if (this.v$.property.IsMonument && items.IsMonument) {
          items.IsBeschermdGezicht = true;
        }
        return items;
      }
    },
    mounted() {
      this.lead.markViewAsVisited(this.$route.name);
      this.presetConstuctionYear();
    },
    watch: {
      'lead.property.ConstructionYear'() {
        this.syncAdviseurLite();
      }
    },
    methods: {
      presetConstuctionYear() {
        console.log('Checking construction year for address');
        if (!this.lead.property.ConstructionYear && this.addressStore.BAG_oorspronkelijkBouwjaar__c) {
          console.log('Setting construction year from address store:', this.addressStore.BAG_oorspronkelijkBouwjaar__c);
          this.lead.property.ConstructionYear = this.addressStore.BAG_oorspronkelijkBouwjaar__c;
        }
        this.syncAdviseurLite();
      },

      syncAdviseurLite() {
        if (this.lead.property.ConstructionYear >= 1992) {
          this.lead.meta.AdviseurLite = Number(this.lead.property.ConstructionYear) >= 1992;
        }
      },

      touchAndValidate() {
        if (this.hasAdviesAccess && this.isInIntakeSection) {
          return true;
        }

        this.v$.property.$touch();
        return !this.v$.property.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      }
    },
  }
</script>

<style lang="scss">
</style>